import { HABI_API_BASE_URL, getAuthHeaders } from "./habiApi";

/**
 * Inicia un cobro online con la pasarela dLocal Go para un pago (`payments` doc).
 *
 * Llama al backend (`/api/dlocal/create-payment`), que crea el pago en dLocal y
 * devuelve la `redirect_url` del checkout hosteado. El monto lo determina el
 * backend a partir del doc de `payments` (no se confía en el cliente). La
 * confirmación real del pago llega de forma asíncrona por webhook; el front debe
 * escuchar el doc de `payments` (onSnapshot) para reflejar `paid: true`.
 *
 * @param {object} params
 * @param {string|number} params.buildingId - buildingid del edificio
 * @param {string} params.paymentId         - id del doc en `payments`
 * @param {string} [params.returnUrl]       - a dónde vuelve el residente tras pagar
 * @returns {Promise<{ redirect_url: string, order_id: string, payment_id: string }>}
 * @throws Error con mensaje descriptivo si falla
 */
export async function initiateDlocalPayment({ buildingId, paymentId, returnUrl }) {
  const headers = await getAuthHeaders();
  let resp;
  try {
    resp = await fetch(`${HABI_API_BASE_URL}/api/dlocal/create-payment`, {
      method: "POST",
      headers,
      body: JSON.stringify({
        building_id: String(buildingId),
        payment_id: String(paymentId),
        return_url: returnUrl || (typeof window !== "undefined" ? window.location.origin : undefined),
      }),
    });
  } catch (e) {
    throw new Error("No se pudo contactar la pasarela de pago. Revisá tu conexión.");
  }

  if (!resp.ok) {
    let detail = "";
    try {
      const err = await resp.json();
      detail = err.detail || "";
    } catch (_) {
      /* sin cuerpo JSON */
    }
    if (resp.status === 503) {
      throw new Error(detail || "La pasarela de pago no está configurada todavía.");
    }
    throw new Error(detail || "No se pudo iniciar el pago online.");
  }

  const data = await resp.json();
  if (!data.redirect_url) {
    throw new Error("La pasarela no devolvió un link de pago.");
  }
  return data;
}
